/* =====================================================================
   Wise — Page panier (sections/wh-cart-page.liquid) · préfixe whcp
   Chargé en defer sur la page panier, après wh-core.js. ES5 (compatible
   ES2017), sans dépendance, idempotent. window.WH est utilisé s'il existe
   (défileurs, format des prix) mais n'est pas obligatoire.

   Ce que fait ce fichier
     - Quantités −/+ et saisie directe : /cart/change.js avec rendu groupé de
       la section (paramètre sections), sans rechargement. Envois groupés
       (anti-rebond), file d'attente, bouton Commander tenu pendant l'envoi.
     - Retirer + « Annuler » (remise au panier avec /cart/add.js).
     - Code promo : mode « rappel » (code enregistré + copier) ou mode
       « appliqué » (/cart/update.js { discount }, verdict réel de Shopify).
     - Dates de livraison estimées, barre Commander collante (mobile),
       suggestions /recommendations/products (cartes produit du thème),
       panier vide : pièces consultées (localStorage wise_recent_products).
     - En-tête : [data-cart-count] et [data-cart-badge] mis à jour.
     - Événement document « wh:cart:updated » (annulable) après chaque
       changement fait ici : detail = { source: 'cart-page', cart, itemCount }.
       Un tiroir qui se resynchronise appelle event.preventDefault().
       Tant que personne ne l'a fait, un clic sur [data-drawer-open] sur la
       page panier ramène en haut du panier au lieu d'ouvrir un tiroir périmé.
     - Écoute : rendu du tiroir par wise.js (#drawer-body), « wh:cart:updated »
       venant d'ailleurs, événements standard Shopify shopify:cart:*,
       retour arrière (pageshow) : la section se recharge alors seule.

   wise.js n'est pas modifié et aucun de ses écouteurs n'est doublé :
   la note ([data-cart-note]) et les cœurs ([data-wish]) restent gérés par
   wise.js ; les formulaires des cartes produit injectées plus tard dans les
   suggestions ne sont pas liés par wise.js (liaison au chargement) : ce
   fichier les gère, et seulement eux.
   ===================================================================== */
(function (window, document) {
  'use strict';

  if (window.__whcpCart) return;
  window.__whcpCart = true;

  var ROUTES = window.WiseRoutes || {};
  var R = {
    cart: ROUTES.cart || '/cart',
    add: ROUTES.cartAdd || '/cart/add',
    change: ROUTES.cartChange || '/cart/change',
    update: ROUTES.cartUpdate || '/cart/update'
  };
  var KEY_RECENT = 'wise_recent_products';
  var KEY_WISH = 'wise_wishlist';
  var KEY_PROMO = 'wise_saved_promo';
  var KEY_FRESH = 'wh_recent_fresh_v1';
  var FRESH_TTL = 20 * 60 * 1000;
  var EVENT = 'wh:cart:updated';
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var NBSP = '\u00a0';

  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  /* Section affichée (une seule par page). */
  var inst = null;

  /* État partagé entre les rendus (la section peut être remplacée). */
  var state = {
    pending: {},      // clé de ligne -> quantité demandée, pas encore envoyée
    sent: {},         // clé de ligne -> quantité envoyée, en attente du rendu
    timers: {},
    removing: {},
    msgs: {},         // clé de ligne -> message à afficher au prochain rendu
    lastRemoved: null,
    inflight: 0,
    queue: Promise.resolve(),
    lastOwn: 0,
    checkoutClick: 0,
    drawerStale: false,
    booted: false,
    globals: false,
    codes: []
  };

  /* ---------- Utilitaires ---------- */
  function noop() {}

  function report(err) {
    if (window.console && typeof window.console.error === 'function') window.console.error('[whcp]', err);
  }

  function reduced() {
    return !!(mqReduce && mqReduce.matches);
  }

  function $$(selector, ctx) {
    var base = ctx || document;
    if (!base || typeof base.querySelectorAll !== 'function') return [];
    return Array.prototype.slice.call(base.querySelectorAll(selector));
  }

  function trim(value) {
    return String(value == null ? '' : value).replace(/^\s+|\s+$/g, '');
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  function sameCode(a, b) {
    return trim(a).toUpperCase() === trim(b).toUpperCase();
  }

  function quote(text) {
    return '“' + text + '”';
  }

  /* Annonce pour les lecteurs d'écran (région #live-region du layout, comme wise.js). */
  function announce(text) {
    var region = document.getElementById('live-region');
    if (!region || !text) return;
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = text;
    }, 60);
  }

  function readJSON(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw == null ? fallback : JSON.parse(raw);
    } catch (err) {
      return fallback;
    }
  }

  /* wise_saved_promo est une simple chaîne (pas du JSON). */
  function readSavedPromo() {
    var code = '';
    try {
      code = window.localStorage.getItem(KEY_PROMO) || '';
    } catch (err) {
      code = '';
    }
    code = trim(code);
    return code.length > 0 && code.length <= 40 ? code : '';
  }

  function money(cents) {
    if (window.WH && typeof window.WH.money === 'function') return window.WH.money(cents);
    var parts = (Math.round(Number(cents) || 0) / 100).toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) + ',' + parts[1] + NBSP + '€';
  }

  function toCents(value) {
    if (typeof value === 'number') return isFinite(value) && value > 0 ? Math.round(value) : 0;
    if (typeof value === 'string' && /^\s*\d+\s*$/.test(value)) return parseInt(value, 10) || 0;
    return 0;
  }

  function makeEvent(name, detail, cancelable) {
    var ev;
    try {
      ev = new window.CustomEvent(name, { bubbles: true, cancelable: !!cancelable, detail: detail });
    } catch (err) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(name, true, !!cancelable, detail);
    }
    return ev;
  }

  /* Icône du thème posée dans un <template data-whcp-icon> de la section. */
  function icon(name) {
    var tpl = inst ? inst.el.querySelector('template[data-whcp-icon="' + name + '"]') : null;
    return tpl ? tpl.innerHTML : '';
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      el.focus();
    }
  }

  function findLine(key) {
    if (!inst || !key) return null;
    var lines = $$('[data-whcp-line]', inst.el);
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].getAttribute('data-key') === key) return lines[i];
    }
    return null;
  }

  function findItem(cart, key) {
    var items = cart && cart.items ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === key) return items[i];
    }
    return null;
  }

  function idle(fn) {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn, { timeout: 2500 });
    else window.setTimeout(fn, 1200);
  }

  /* ---------- Requêtes ---------- */
  function jsonPost(url, body) {
    return window.fetch(url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () {
        return {};
      }).then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || '');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  /* Appel à l'API panier avec rendu groupé de la section (une seule requête). */
  function cartPost(url, body) {
    if (inst && inst.id) {
      body.sections = [inst.id];
      body.sections_url = window.location.pathname;
    }
    return jsonPost(url, body);
  }

  function getCart() {
    return window.fetch(R.cart + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  function fetchText(url) {
    return window.fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    });
  }

  function sectionUrl() {
    return R.cart + (R.cart.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(inst.id);
  }

  /* File d'attente : une seule opération panier à la fois, dans l'ordre. */
  function enqueue(task) {
    var run = function () {
      var result;
      try {
        result = task();
      } catch (err) {
        report(err);
        result = null;
      }
      return Promise.resolve(result).catch(function (err) {
        report(err);
        return null;
      });
    };
    state.queue = state.queue.then(run, run);
    return state.queue;
  }

  function friendly(err) {
    var msg = err && err.message ? trim(err.message) : '';
    if (!msg || /failed to fetch|networkerror|load failed|network request failed/i.test(msg)) {
      return 'The connection failed. Please check your network and try again.';
    }
    return msg;
  }

  /* Modifie le panier, affiche le rendu renvoyé par Shopify, prévient le reste de la page. */
  function mutate(request, opts) {
    opts = opts || {};
    state.inflight++;
    syncCheckout();
    return enqueue(function () {
      return request().then(function (data) {
        state.lastOwn = Date.now();
        var html = data && data.sections && inst ? data.sections[inst.id] : null;
        var done = html ? Promise.resolve(render(html, opts)) : refresh(opts);
        return done.then(function () {
          var cart = data && typeof data.item_count === 'number' ? data : null;
          afterMutation(cart);
          return { ok: true, data: data, cart: cart };
        });
      }, function (err) {
        report(err);
        var msg = friendly(err);
        if (opts.key) state.msgs[opts.key] = msg;
        return refresh({}).catch(noop).then(function () {
          if (!opts.key && !opts.quiet) showAlert(msg);
          announce(msg);
          return { ok: false, error: msg, status: err && err.status };
        });
      });
    }).then(function (res) {
      state.inflight = Math.max(0, state.inflight - 1);
      syncCheckout();
      return res || { ok: false, error: friendly(null) };
    });
  }

  function refresh(opts) {
    if (!inst || !inst.id) return Promise.resolve();
    return window.fetch(sectionUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).then(function (html) {
      render(html, opts || {});
    });
  }

  /* ---------- Rendu ---------- */
  function render(html, opts) {
    opts = opts || {};
    if (!inst || !html) return;
    var doc = new window.DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-whcp]');
    if (!fresh) return;
    var cur = inst.el;
    var curEmpty = cur.hasAttribute('data-whcp-empty');
    var newEmpty = fresh.hasAttribute('data-whcp-empty');

    if (curEmpty !== newEmpty) {
      swapRoot(fresh, opts);
      return;
    }

    if (!curEmpty && (opts.force || fresh.getAttribute('data-sig') !== cur.getAttribute('data-sig'))) {
      var focus = rememberFocus();
      $$('[data-whcp-region]', cur).forEach(function (region) {
        var name = region.getAttribute('data-whcp-region');
        var next = fresh.querySelector('[data-whcp-region="' + name + '"]');
        if (next && region.innerHTML !== next.innerHTML) morph(region, next);
      });
      cur.setAttribute('data-sig', fresh.getAttribute('data-sig') || '');
      cur.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
      restoreFocus(focus, opts);
    }
    state.sent = {};
    afterRender(opts);
  }

  /* Remplace le contenu d'une zone ; la barre de livraison glisse de l'ancienne à la nouvelle largeur. */
  function morph(region, next) {
    var oldFill = region.querySelector('[data-whcp-fill]');
    var from = oldFill ? oldFill.style.width : '';
    region.innerHTML = next.innerHTML;
    var fill = region.querySelector('[data-whcp-fill]');
    if (fill && from && !reduced()) {
      var to = fill.style.width;
      if (to && to !== from) {
        fill.style.width = from;
        void fill.offsetWidth;
        fill.style.width = to;
      }
    }
  }

  /* Panier plein <-> panier vide : toute la section change. */
  function swapRoot(fresh, opts) {
    var old = inst.el;
    var node = document.importNode(fresh, true);
    teardown();
    old.parentNode.replaceChild(node, old);
    inst = null;
    state.sent = {};
    boot(node);
    if (!inst) return;
    if (window.WH && typeof window.WH.init === 'function') {
      try {
        window.WH.init(node);
      } catch (err) {
        report(err);
      }
    }
    afterRender(opts);
    /* Pas de saut de focus quand le changement vient d'ailleurs (tiroir ouvert, autre onglet). */
    if (!opts.focusVariant && !opts.external) focusEl(node.querySelector('[data-whcp-title]'));
  }

  function afterRender(opts) {
    if (!inst) return;
    $$('[data-whcp-line]', inst.el).forEach(function (line) {
      var key = line.getAttribute('data-key');
      var busy = has(state.pending, key) || has(state.removing, key);
      var input = line.querySelector('[data-whcp-qty]');
      if (input && has(state.pending, key)) {
        /* quantité demandée, pas encore envoyée : on garde ce que le client a choisi */
        input.value = String(state.pending[key]);
      } else if (input && document.activeElement !== input && !has(state.sent, key)) {
        /* sinon le champ montre la quantité réelle du panier (ex. changement refusé) */
        var server = line.getAttribute('data-qty');
        if (server && input.value !== server) input.value = server;
      }
      line.classList.toggle('is-busy', has(state.pending, key));
      line.classList.toggle('is-removing', has(state.removing, key));
      if (busy) line.setAttribute('aria-busy', 'true');
      else line.removeAttribute('aria-busy');
      if (has(state.msgs, key)) {
        setLineMsg(line, state.msgs[key]);
        delete state.msgs[key];
      }
    });
    state.msgs = {};
    enhance(inst.el);
    syncWish(inst.el);
    if (opts && opts.flashVariant) flashVariant(opts.flashVariant, opts.focusVariant);
    syncCheckout();
  }

  function rememberFocus() {
    var active = document.activeElement;
    if (!active || !inst || !inst.el.contains(active)) return null;
    var line = active.closest ? active.closest('[data-whcp-line]') : null;
    return {
      el: active,
      key: line ? line.getAttribute('data-key') : null,
      ctl: active.getAttribute('data-whcp-focus') || ''
    };
  }

  /* Le focus ne doit jamais se perdre quand une ligne est redessinée ou retirée. */
  function restoreFocus(saved, opts) {
    if (!saved || !inst || document.body.contains(saved.el)) return;
    var target = null;
    if (opts && has(opts, 'focusKey')) {
      var neighbor = opts.focusKey ? findLine(opts.focusKey) : null;
      target = neighbor ? neighbor.querySelector('[data-whcp-focus="title"]') : null;
    } else if (saved.key) {
      var line = findLine(saved.key);
      if (line) {
        target = (saved.ctl && line.querySelector('[data-whcp-focus="' + saved.ctl + '"]')) ||
          line.querySelector('[data-whcp-focus="title"]');
      }
    }
    focusEl(target || inst.el.querySelector('[data-whcp-title]'));
  }

  /* Liens −/+ et Retirer : ce sont des liens sans JS, des boutons avec. */
  function enhance(scope) {
    $$('a[data-whcp-step], a[data-whcp-remove]', scope).forEach(function (link) {
      if (!link.hasAttribute('role')) link.setAttribute('role', 'button');
    });
  }

  function setLineMsg(line, text) {
    var box = line.querySelector('[data-whcp-line-msg]');
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
  }

  function flashVariant(variantId, focus) {
    if (!inst) return;
    var line = inst.el.querySelector('[data-whcp-line][data-variant="' + String(variantId) + '"]');
    if (!line) return;
    if (!reduced()) {
      line.classList.remove('is-new');
      void line.offsetWidth;
      line.classList.add('is-new');
      window.setTimeout(function () {
        line.classList.remove('is-new');
      }, 1900);
    }
    if (focus) focusEl(line.querySelector('[data-whcp-focus="title"]'));
  }

  function showAlert(text) {
    var box = inst ? inst.el.querySelector('[data-whcp-alert]') : null;
    if (!box) return;
    box.textContent = text;
    box.hidden = false;
  }

  function hideAlert() {
    var box = inst ? inst.el.querySelector('[data-whcp-alert]') : null;
    if (box) box.hidden = true;
  }

  /* ---------- Après un changement fait ici ---------- */
  function setHeaderCount(count, quiet) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
    });
    $$('[data-cart-badge]').forEach(function (el) {
      el.hidden = count === 0;
      if (quiet) return;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  function withoutSections(cart) {
    var out = {};
    for (var key in cart) {
      if (has(cart, key) && key !== 'sections') out[key] = cart[key];
    }
    return out;
  }

  function afterMutation(cart) {
    hideAlert();
    var count = inst ? parseInt(inst.el.getAttribute('data-count'), 10) : NaN;
    if (cart && typeof cart.item_count === 'number') count = cart.item_count;
    if (count >= 0) setHeaderCount(count, false);

    var detail = { source: 'cart-page', cart: cart ? withoutSections(cart) : null, itemCount: count >= 0 ? count : null };
    var unhandled = document.dispatchEvent(makeEvent(EVENT, detail, true));
    state.drawerStale = unhandled && !!document.getElementById('cart-drawer');

    if (promoEls()) {
      if (cart) renderCodes(cart);
      else getCart().then(renderCodes).catch(noop);
    }
  }

  /* Le bouton Commander attend la fin des mises à jour (pas de paiement sur un panier périmé). */
  function syncCheckout() {
    if (!inst) return;
    var busy = state.inflight > 0 || Object.keys(state.pending).length > 0;
    inst.el.classList.toggle('is-busy', busy);
    $$('[data-whcp-checkout]', inst.el).forEach(function (btn) {
      if (busy) {
        if (!btn.disabled) {
          btn.disabled = true;
          btn.setAttribute('data-whcp-held', '');
        }
        btn.setAttribute('aria-busy', 'true');
      } else {
        if (btn.hasAttribute('data-whcp-held')) {
          btn.disabled = false;
          btn.removeAttribute('data-whcp-held');
        }
        btn.removeAttribute('aria-busy');
      }
    });
  }

  /* ---------- Quantités ---------- */
  function currentQty(line) {
    var key = line.getAttribute('data-key');
    if (has(state.pending, key)) return state.pending[key];
    var input = line.querySelector('[data-whcp-qty]');
    var value = input ? parseInt(input.value, 10) : NaN;
    if (!(value >= 0)) value = parseInt(line.getAttribute('data-qty'), 10) || 1;
    return value;
  }

  function stepQty(btn) {
    var line = btn.closest('[data-whcp-line]');
    if (!line || has(state.removing, line.getAttribute('data-key'))) return;
    var delta = parseInt(btn.getAttribute('data-whcp-step'), 10) || 0;
    var next = Math.max(0, currentQty(line) + delta);
    if (next === 0) {
      removeLine(line);
      return;
    }
    var input = line.querySelector('[data-whcp-qty]');
    if (input) input.value = String(next);
    queueQty(line, next, 400);
  }

  function queueQty(line, qty, delay) {
    var key = line.getAttribute('data-key');
    state.pending[key] = qty;
    line.classList.add('is-busy');
    line.setAttribute('aria-busy', 'true');
    window.clearTimeout(state.timers[key]);
    state.timers[key] = window.setTimeout(function () {
      commitQty(key);
    }, delay);
    syncCheckout();
  }

  function commitQty(key) {
    delete state.timers[key];
    if (!has(state.pending, key)) return;
    var qty = state.pending[key];
    delete state.pending[key];
    var line = findLine(key);
    var before = line ? parseInt(line.getAttribute('data-qty'), 10) : NaN;
    var title = line ? line.getAttribute('data-title') : '';
    if (qty === before) {
      afterRender({});
      return;
    }
    state.sent[key] = qty;
    mutate(function () {
      return cartPost(R.change, { id: key, quantity: qty });
    }, { key: key }).then(function (res) {
      if (!res.ok) return;
      var item = res.cart ? findItem(res.cart, key) : null;
      var got = item ? item.quantity : qty;
      if (item && got < qty) {
        var current = findLine(key);
        if (current) setLineMsg(current, 'Maximum quantity available: ' + got + '.');
        announce('Maximum quantity available for ' + title + ': ' + got + '.');
      } else {
        announce('Quantity updated: ' + got + ' × ' + title + '.');
      }
    });
  }

  /* Saisie directe dans le champ quantité (validée à la sortie du champ ou avec Entrée). */
  function commitInput(input) {
    var line = input.closest('[data-whcp-line]');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var server = parseInt(line.getAttribute('data-qty'), 10) || 1;
    var value = parseInt(input.value, 10);
    if (!(value >= 0) || value > 999) {
      input.value = String(has(state.pending, key) ? state.pending[key] : server);
      return;
    }
    if (value === 0) {
      removeLine(line);
      return;
    }
    if (has(state.pending, key) && state.pending[key] === value) return;
    if (!has(state.pending, key) && (state.sent[key] === value || (!has(state.sent, key) && value === server))) return;
    queueQty(line, value, 0);
  }

  /* ---------- Retirer, annuler ---------- */
  function snapshot(line) {
    var props = {};
    try {
      props = JSON.parse(line.getAttribute('data-props') || '{}') || {};
    } catch (err) {
      props = {};
    }
    var snap = {
      id: parseInt(line.getAttribute('data-variant'), 10) || 0,
      quantity: parseInt(line.getAttribute('data-qty'), 10) || 1,
      title: line.getAttribute('data-title') || 'Article',
      properties: props
    };
    var plan = parseInt(line.getAttribute('data-plan'), 10);
    if (plan > 0) snap.sellingPlan = plan;
    return snap;
  }

  function removeLine(line) {
    if (!line) return;
    var key = line.getAttribute('data-key');
    if (has(state.removing, key)) return;
    window.clearTimeout(state.timers[key]);
    delete state.timers[key];
    delete state.pending[key];

    var snap = snapshot(line);
    var neighbor = line.nextElementSibling || line.previousElementSibling;
    var focusKey = neighbor && neighbor.hasAttribute('data-whcp-line') ? neighbor.getAttribute('data-key') : null;

    state.removing[key] = true;
    line.classList.add('is-removing');
    line.setAttribute('aria-busy', 'true');
    hideUndo();

    mutate(function () {
      return cartPost(R.change, { id: key, quantity: 0 });
    }, { key: key, focusKey: focusKey }).then(function (res) {
      delete state.removing[key];
      var stillThere = findLine(key);
      if (stillThere) {
        stillThere.classList.remove('is-removing');
        stillThere.removeAttribute('aria-busy');
      }
      if (!res.ok) return;
      state.lastRemoved = snap;
      showUndo(snap);
      announce(snap.title + ' has been removed from your bag. An undo button is available.');
    });
  }

  function showUndo(snap) {
    var box = inst ? inst.el.querySelector('[data-whcp-undo]') : null;
    if (!box || !snap) return;
    box.innerHTML = '<p class="whcp-undo__txt"></p>' +
      '<button type="button" class="whcp-undo__btn" data-whcp-undo-btn>Undo</button>' +
      '<button type="button" class="whcp-undo__x" data-whcp-undo-close aria-label="Close this message">' + icon('close') + '</button>';
    box.querySelector('.whcp-undo__txt').textContent = quote(snap.title) + ' has been removed.';
    box.hidden = false;
  }

  function hideUndo() {
    var box = inst ? inst.el.querySelector('[data-whcp-undo]') : null;
    if (!box) return;
    box.hidden = true;
    box.innerHTML = '';
  }

  function undoRemove(btn) {
    var snap = state.lastRemoved;
    if (!snap || !snap.id) {
      hideUndo();
      return;
    }
    btn.disabled = true;
    var item = { id: snap.id, quantity: snap.quantity };
    if (snap.properties && Object.keys(snap.properties).length) item.properties = snap.properties;
    if (snap.sellingPlan) item.selling_plan = snap.sellingPlan;
    mutate(function () {
      return cartPost(R.add, { items: [item] });
    }, { flashVariant: snap.id, focusVariant: true }).then(function (res) {
      if (!res.ok) {
        if (document.body.contains(btn)) btn.disabled = false;
        return;
      }
      state.lastRemoved = null;
      hideUndo();
      announce(snap.title + ' is back in your bag.');
    });
  }

  /* ---------- Code promo ---------- */
  function promoEls() {
    var root = inst ? inst.el.querySelector('[data-whcp-promo="apply"]') : null;
    if (!root) return null;
    return {
      root: root,
      input: root.querySelector('[data-whcp-promo-input]'),
      btn: root.querySelector('[data-whcp-promo-apply]'),
      msg: root.querySelector('[data-whcp-promo-msg]'),
      list: root.querySelector('[data-whcp-codes]'),
      suggest: root.querySelector('[data-whcp-promo-suggest]')
    };
  }

  function promoMsg(text, kind) {
    var p = promoEls();
    if (!p || !p.msg) return;
    p.msg.textContent = text || '';
    p.msg.hidden = !text;
    p.msg.classList.toggle('is-error', kind === 'error');
    p.msg.classList.toggle('is-ok', kind === 'ok');
    if (text) announce(text);
  }

  function findCode(list, code) {
    for (var i = 0; i < list.length; i++) {
      if (list[i] && sameCode(list[i].code, code)) return list[i];
    }
    return null;
  }

  /* La remise du code apparaît-elle dans le panier (remise sur articles ou sur le total) ? */
  function codeHasAmount(cart, code) {
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      if (apps[i] && sameCode(apps[i].title, code)) return true;
    }
    var items = cart.items || [];
    for (var j = 0; j < items.length; j++) {
      var allocations = items[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocations.length; k++) {
        var app = allocations[k] && allocations[k].discount_application;
        if (app && sameCode(app.title, code)) return true;
      }
    }
    return false;
  }

  function discountUrl(code) {
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
  }

  function setPromoBusy(on) {
    var p = promoEls();
    if (!p || !p.btn) return;
    p.btn.disabled = !!on;
    if (on) p.btn.setAttribute('aria-busy', 'true');
    else p.btn.removeAttribute('aria-busy');
  }

  function renderCodes(cart) {
    var p = promoEls();
    if (!p) return;
    if (cart && Array.isArray(cart.discount_codes)) state.codes = cart.discount_codes.slice();
    if (p.list) {
      p.list.innerHTML = state.codes.map(function (d) {
        var off = d.applicable === false;
        return '<li class="whcp-codepill' + (off ? ' is-off' : '') + '">' +
          (off ? '' : icon('check')) +
          '<span>' + esc(d.code) + '</span>' +
          (off ? '<span class="whcp-codepill__note">not valid for this bag</span>' : '') +
          '<button type="button" class="whcp-codepill__x" data-whcp-code-remove="' + esc(d.code) + '" aria-label="Remove code ' + esc(d.code) + '">' + icon('close') + '</button>' +
          '</li>';
      }).join('');
    }
    if (p.suggest) {
      var saved = readSavedPromo();
      var already = saved ? !!findCode(state.codes, saved) : true;
      /* wise.js préremplit déjà #promo-code avec ce code : pas de doublon de suggestion. */
      var prefilled = saved && p.input ? sameCode(p.input.value, saved) : false;
      p.suggest.hidden = !saved || already || prefilled;
      var slot = p.suggest.querySelector('[data-whcp-saved-code]');
      if (slot) slot.textContent = saved.toUpperCase();
    }
  }

  function applyPromo() {
    var p = promoEls();
    if (!p || !p.input) return;
    var code = trim(p.input.value);
    if (!code) {
      promoMsg('Enter your discount code.', 'error');
      p.input.focus();
      return;
    }
    if (findCode(state.codes, code)) {
      promoMsg('This code is already applied to your bag.', 'ok');
      return;
    }
    var codes = state.codes.map(function (d) { return d.code; }).concat([code]);
    setPromoBusy(true);
    mutate(function () {
      return cartPost(R.update, { discount: codes.join(',') });
    }, { quiet: true }).then(function (res) {
      setPromoBusy(false);
      if (!res.ok) {
        promoMsg(res.error || 'The code could not be checked. Please try again.', 'error');
        return;
      }
      var cart = res.cart;
      if (!cart || !Array.isArray(cart.discount_codes)) {
        /* Ancienne API panier sans prise en charge des codes : adresse de réduction Shopify. */
        window.location.href = discountUrl(code);
        return;
      }
      var entry = findCode(cart.discount_codes, code);
      if (!entry || entry.applicable === false) {
        promoMsg('The code ' + quote(code) + ' is not valid for this bag.', 'error');
        var keep = cart.discount_codes.filter(function (d) {
          return !sameCode(d.code, code);
        }).map(function (d) { return d.code; });
        mutate(function () {
          return cartPost(R.update, { discount: keep.join(',') });
        }, { quiet: true }).then(function (r2) {
          if (r2.ok && r2.cart) renderCodes(r2.cart);
        });
        return;
      }
      var p2 = promoEls();
      if (p2 && p2.input) p2.input.value = '';
      if (codeHasAmount(cart, entry.code)) {
        promoMsg('Code ' + quote(entry.code) + ' applied.', 'ok');
      } else {
        promoMsg('Code ' + quote(entry.code) + ' accepted: its delivery discount will show at checkout.', 'ok');
      }
      renderCodes(cart);
    });
  }

  function removeCode(code) {
    var keep = state.codes.filter(function (d) {
      return !sameCode(d.code, code);
    }).map(function (d) { return d.code; });
    mutate(function () {
      return cartPost(R.update, { discount: keep.join(',') });
    }, { quiet: true }).then(function (res) {
      if (!res.ok) {
        promoMsg(res.error, 'error');
        return;
      }
      if (res.cart) renderCodes(res.cart);
      promoMsg('Code ' + quote(code) + ' removed.', '');
      var p = promoEls();
      if (p && p.input) focusEl(p.input);
    });
  }

  /* Mode « rappel » : le code enregistré (roue, espace membre) se copie en un geste. */
  function setupSaved(el) {
    var box = el.querySelector('[data-whcp-promo="remind"] [data-whcp-saved]');
    if (!box) return;
    var code = readSavedPromo();
    if (!code) return;
    var slot = box.querySelector('[data-whcp-saved-code]');
    if (slot) slot.textContent = code.toUpperCase();
    box.hidden = false;
  }

  function copyText(text) {
    if (window.navigator.clipboard && window.isSecureContext) {
      return window.navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.top = '-1000px';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (err) {
        ok = false;
      }
      document.body.removeChild(area);
      if (ok) resolve();
      else reject(new Error('copie impossible'));
    });
  }

  function copyCode(btn) {
    var box = btn.closest('[data-whcp-saved]');
    var slot = box ? box.querySelector('[data-whcp-saved-code]') : null;
    var code = slot ? trim(slot.textContent) : '';
    if (!code) return;
    var label = btn.querySelector('[data-whcp-copy-label]');
    copyText(code).then(function () {
      btn.classList.add('is-done');
      if (label) label.textContent = 'Copied';
      announce('Code ' + code + ' copied. Paste it into the discount code field at checkout.');
      window.setTimeout(function () {
        btn.classList.remove('is-done');
        if (label) label.textContent = 'Copy';
      }, 2400);
    }, function () {
      announce('Could not copy: please note the code ' + code + '.');
    });
  }

  /* ---------- Favoris (crochet [data-wish] de wise.js) ---------- */
  function syncWish(scope) {
    var list = readJSON(KEY_WISH, []);
    var wished = {};
    if (Array.isArray(list)) {
      list.forEach(function (p) {
        if (p && typeof p.handle === 'string') wished[p.handle] = true;
      });
    }
    $$('[data-wish]', scope).forEach(function (btn) {
      var on = has(wished, btn.getAttribute('data-handle') || '');
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var off = btn.querySelector('.wish-off');
      var onIcon = btn.querySelector('.wish-on');
      if (off) off.hidden = on;
      if (onIcon) onIcon.hidden = !on;
    });
  }

  /* ---------- Dates de livraison estimées ---------- */
  function deliveryDay(days) {
    var now = new Date();
    var day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
    if (day.getDay() === 0) day.setDate(day.getDate() + 1); /* pas de livraison le dimanche */
    return day;
  }

  function dayLabel(date) {
    return String(date.getDate());
  }

  /* British form: "on 17 October", "between 17 and 22 October", "between 30 October and 2 November". */
  function rangeLabel(a, b) {
    if (a.getTime() === b.getTime()) return 'on ' + dayLabel(a) + ' ' + MONTHS[a.getMonth()];
    if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) {
      return 'between ' + dayLabel(a) + ' and ' + dayLabel(b) + ' ' + MONTHS[b.getMonth()];
    }
    return 'between ' + dayLabel(a) + ' ' + MONTHS[a.getMonth()] + ' and ' + dayLabel(b) + ' ' + MONTHS[b.getMonth()];
  }

  function setupEstimate(el) {
    var box = el.querySelector('[data-whcp-est]');
    var out = box ? box.querySelector('[data-whcp-est-dates]') : null;
    if (!out) return;
    var min = parseInt(box.getAttribute('data-min'), 10);
    var max = parseInt(box.getAttribute('data-max'), 10);
    if (!(min > 0) || !(max >= min)) return;
    out.textContent = rangeLabel(deliveryDay(min), deliveryDay(max));
  }

  /* ---------- Lien « Continuer mes achats » : retour à la dernière collection ou fiche ---------- */
  function setupContinue(el) {
    var link = el.querySelector('[data-whcp-continue="auto"]');
    if (!link || !document.referrer) return;
    try {
      var ref = new window.URL(document.referrer);
      if (ref.origin !== window.location.origin) return;
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections|products|search)(?:\/|$)/i.test(ref.pathname)) return;
      link.setAttribute('href', ref.pathname + ref.search);
    } catch (err) {
      /* adresse illisible : on garde le lien par défaut */
    }
  }

  /* ---------- Barre « Commander » collante (mobile) ---------- */
  function setupBar(el) {
    var bar = el.querySelector('[data-whcp-bar]');
    if (!bar) return;
    var cta = el.querySelector('[data-whcp-cta]');
    if (!cta || !('IntersectionObserver' in window)) {
      bar.classList.add('is-on');
      return;
    }
    /* Le bas de l'écran est occupé par la barre d'onglets et par cette barre. */
    var io = new window.IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      var below = entry.boundingClientRect.top > 0;
      bar.classList.toggle('is-on', below && entry.intersectionRatio < 0.9);
    }, { threshold: [0, 0.9, 1], rootMargin: '0px 0px -140px 0px' });
    io.observe(cta);
    inst.observers.push(io);
  }

  /* ---------- Suggestions (cartes produit du thème) ---------- */
  function parsePayload(html) {
    var doc = new window.DOMParser().parseFromString(html, 'text/html');
    var payload = doc.querySelector('[data-whcp-reco-payload]');
    if (!payload) return null;
    return Array.prototype.slice.call(payload.querySelectorAll('.whcp-reco__item'));
  }

  function updateScroller(box) {
    var scroller = box.querySelector('[data-wh-scroller]');
    if (!scroller || !window.WH || typeof window.WH.scroller !== 'function') return;
    try {
      var api = window.WH.scroller(scroller);
      if (api && typeof api.update === 'function') api.update();
    } catch (err) {
      report(err);
    }
  }

  function loadReco(box) {
    var url = box.getAttribute('data-url');
    var alt = box.getAttribute('data-url-alt');
    if (!url) return;
    fetchText(url).then(parsePayload, function () {
      return null;
    }).then(function (items) {
      if (items === null && alt) {
        return fetchText(alt).then(parsePayload, function () {
          return null;
        });
      }
      return items;
    }).then(function (items) {
      if (!items || !items.length || !document.body.contains(box)) return;
      var list = box.querySelector('[data-whcp-reco-list]');
      if (!list) return;
      list.innerHTML = '';
      items.forEach(function (li) {
        list.appendChild(document.importNode(li, true));
      });
      box.hidden = false;
      if (!reduced()) box.classList.add('is-in');
      syncWish(box);
      updateScroller(box);
    }).catch(report);
  }

  function setupReco(el) {
    var box = el.querySelector('[data-whcp-reco]');
    if (!box || box.__whcpReco) return;
    box.__whcpReco = true;
    idle(function () {
      loadReco(box);
    });
  }

  function recoMsg(text) {
    var box = inst ? inst.el.querySelector('[data-whcp-reco-msg]') : null;
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
  }

  function addVariant(variantId, btn, card) {
    if (!variantId || !inst) return;
    recoMsg('');
    var original = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    mutate(function () {
      return cartPost(R.add, { items: [{ id: variantId, quantity: 1 }] });
    }, { quiet: true, flashVariant: variantId }).then(function (res) {
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
      if (!res.ok) {
        recoMsg(res.error);
        return;
      }
      if (typeof window.wiseFlyToCart === 'function' && card) {
        try {
          window.wiseFlyToCart(card.querySelector('img'));
        } catch (err) {
          /* animation facultative */
        }
      }
      if (btn) {
        btn.classList.add('is-added');
        btn.textContent = 'Added to bag';
        window.setTimeout(function () {
          btn.classList.remove('is-added');
          btn.innerHTML = original;
        }, 1800);
      }
      announce('Item added to your bag.');
    });
  }

  /* Choix de la taille des cartes injectées (wise.js ne lie que les cartes présentes au chargement). */
  function closeQuick(focusOpener, except) {
    if (!inst) return;
    $$('[data-whcp-reco] [data-card-quick]', inst.el).forEach(function (wrap) {
      if (wrap === except) return;
      var panel = wrap.querySelector('[data-quick-panel]');
      var opener = wrap.querySelector('[data-quick-open]');
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
        if (focusOpener) focusEl(opener);
      }
    });
  }

  function toggleQuick(opener) {
    var wrap = opener.closest('[data-card-quick]');
    var panel = wrap ? wrap.querySelector('[data-quick-panel]') : null;
    if (!panel) return;
    var willOpen = panel.hidden;
    closeQuick(false, wrap);
    panel.hidden = !willOpen;
    opener.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen) focusEl(panel.querySelector('[data-quick-variant]:not([disabled])'));
  }

  /* ---------- Panier vide : pièces consultées sur l'appareil ---------- */
  function safeUrl(value) {
    var url = trim(value);
    if (!url) return '';
    if (url.charAt(0) === '/' && url.charAt(1) !== '/') return url;
    try {
      var parsed = new window.URL(url, window.location.href);
      if (parsed.origin === window.location.origin) return parsed.pathname + parsed.search;
    } catch (err) {
      /* adresse illisible */
    }
    return '';
  }

  function safeImg(value) {
    var src = trim(value);
    if (/^(https?:)?\/\//i.test(src) || src.charAt(0) === '/') return src;
    return '';
  }

  function isCdn(src) {
    return /\/cdn\/shop\/|cdn\.shopify\.com/.test(src);
  }

  function sized(src, width) {
    if (!src || !isCdn(src)) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + width);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function readRecent() {
    var raw = readJSON(KEY_RECENT, []);
    var out = [];
    var seen = {};
    if (!Array.isArray(raw)) return out;
    raw.forEach(function (p) {
      if (!p || typeof p !== 'object' || typeof p.handle !== 'string' || !p.handle || has(seen, p.handle)) return;
      var url = safeUrl(p.url);
      if (!url) return;
      seen[p.handle] = true;
      out.push({
        handle: p.handle,
        title: typeof p.title === 'string' ? trim(p.title) : '',
        url: url,
        img: safeImg(p.img),
        price: toCents(p.price),
        compare: 0,
        varies: false,
        available: true,
        vendor: typeof p.vendor === 'string' ? trim(p.vendor) : ''
      });
    });
    return out;
  }

  function recentInfo(p) {
    var html = '';
    if (p.vendor) html += '<p class="wh-mini__brand">' + esc(p.vendor) + '</p>';
    html += '<h3 class="wh-mini__title"><a class="wh-mini__link" href="' + esc(p.url) + '">' + esc(p.title || 'View item') + '</a></h3>';
    if (p.price > 0) {
      var sale = p.compare > p.price;
      var from = p.varies ? '<span class="wh-price__from">From</span> ' : '';
      html += '<p class="wh-prices wh-mini__prices">';
      if (sale) {
        html += '<span class="wh-price wh-price--sale"><span class="wh-vh">Sale price:</span> ' + from + esc(money(p.price)) + '</span> ' +
          '<s class="wh-price-old"><span class="wh-vh">Was:</span> ' + esc(money(p.compare)) + '</s>';
      } else {
        html += '<span class="wh-price">' + from + esc(money(p.price)) + '</span>';
      }
      html += '</p>';
    }
    return html;
  }

  function recentCard(p) {
    var media;
    if (p.img) {
      var srcset = isCdn(p.img)
        ? ' srcset="' + [180, 270, 360, 540].map(function (w) { return esc(sized(p.img, w)) + ' ' + w + 'w'; }).join(', ') + '"' +
          ' sizes="(min-width: 1024px) 15vw, (min-width: 750px) 22vw, 40vw"'
        : '';
      media = '<img class="wh-mini__img" src="' + esc(sized(p.img, 360)) + '"' + srcset + ' alt="" width="400" height="400" loading="lazy" decoding="async">';
    } else {
      media = '<span class="wh-mini__ph" aria-hidden="true">' + esc((p.vendor || p.title || '').slice(0, 24)) + '</span>';
    }
    return '<li class="wh-scroller__item" data-key="' + esc(p.handle) + '">' +
      '<div class="wh-mini wh-mini--sm">' +
        '<div class="wh-mini__media" data-whcp-recent-media>' + media + '</div>' +
        '<div class="wh-mini__body" data-whcp-recent-info>' + recentInfo(p) + '</div>' +
      '</div></li>';
  }

  /* Cache de session partagé avec la section « Vu récemment » de l'accueil (même clé, même format). */
  function loadFresh() {
    var out = {};
    try {
      var data = JSON.parse(window.sessionStorage.getItem(KEY_FRESH) || 'null');
      var limit = Date.now() - FRESH_TTL;
      if (data && typeof data === 'object') {
        for (var key in data) {
          if (has(data, key) && data[key] && data[key].t > limit) out[key] = data[key];
        }
      }
    } catch (err) {
      /* stockage de session indisponible */
    }
    return out;
  }

  function saveFresh(cache) {
    try {
      window.sessionStorage.setItem(KEY_FRESH, JSON.stringify(cache));
    } catch (err) {
      /* quota ou navigation privée : sans conséquence */
    }
  }

  function normalize(d) {
    if (!d || typeof d !== 'object') return null;
    return {
      title: typeof d.title === 'string' ? trim(d.title) : '',
      vendor: typeof d.vendor === 'string' ? trim(d.vendor) : '',
      price: toCents(d.price),
      compare: toCents(d.compare_at_price),
      varies: d.price_varies === true,
      available: d.available !== false,
      img: safeImg(typeof d.featured_image === 'string' ? d.featured_image : '')
    };
  }

  function fetchProduct(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return window.fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (res.status === 404) return { t: Date.now(), gone: true };
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json().then(function (data) {
        return { t: Date.now(), d: normalize(data) };
      });
    });
  }

  function applyFresh(box, p, rec) {
    var items = $$('[data-whcp-recent-list] > li', box);
    var li = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-key') === p.handle) li = items[i];
    }
    if (!li || !rec) return;
    if (rec.gone) {
      li.parentNode.removeChild(li);
      return;
    }
    var d = rec.d || {};
    var merged = {
      handle: p.handle,
      url: p.url,
      img: p.img || d.img || '',
      title: d.title || p.title,
      vendor: d.vendor || p.vendor,
      price: d.price > 0 ? d.price : p.price,
      compare: d.price > 0 ? d.compare : 0,
      varies: !!d.varies,
      available: d.available !== false
    };
    var info = li.querySelector('[data-whcp-recent-info]');
    if (info) info.innerHTML = recentInfo(merged);
    var mini = li.querySelector('.wh-mini');
    var media = li.querySelector('[data-whcp-recent-media]');
    if (mini) mini.classList.toggle('is-soldout', !merged.available);
    if (media) {
      var badge = media.querySelector('.wh-mini__badge');
      if (!merged.available && !badge) {
        badge = document.createElement('span');
        badge.className = 'wh-badge wh-badge--light wh-mini__badge';
        badge.textContent = 'Sold out';
        media.appendChild(badge);
      } else if (merged.available && badge) {
        media.removeChild(badge);
      }
    }
  }

  function refreshRecent(box, items) {
    if (typeof window.fetch !== 'function') return;
    var cache = loadFresh();
    var todo = [];
    items.forEach(function (p) {
      if (has(cache, p.handle)) applyFresh(box, p, cache[p.handle]);
      else todo.push(p);
    });
    var index = 0;
    function next() {
      if (index >= todo.length) return Promise.resolve();
      var p = todo[index++];
      return fetchProduct(p.handle).then(function (rec) {
        cache[p.handle] = rec;
        saveFresh(cache);
        applyFresh(box, p, rec);
      }, noop).then(next);
    }
    Promise.all([next(), next(), next()]).then(function () {
      if (!box.querySelector('[data-whcp-recent-list] > li')) box.hidden = true;
      else updateScroller(box);
    });
  }

  function setupRecent(el) {
    var box = el.querySelector('[data-whcp-recent]');
    if (!box || box.__whcpRecent) return;
    box.__whcpRecent = true;
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 8;
    var items = readRecent().slice(0, limit);
    var track = box.querySelector('[data-whcp-recent-list]');
    if (!items.length || !track) return;
    track.innerHTML = items.map(recentCard).join('');
    box.hidden = false;
    updateScroller(box);
    refreshRecent(box, items);
  }

  /* ---------- Écouteurs de la section ---------- */
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el;

    if (t.closest('[data-whcp-checkout]')) {
      /* Repère pour onSubmit (navigateurs sans event.submitter). */
      state.checkoutClick = Date.now();
      return;
    }
    if ((el = t.closest('[data-whcp-step]'))) {
      e.preventDefault();
      stepQty(el);
      return;
    }
    if ((el = t.closest('[data-whcp-remove]'))) {
      e.preventDefault();
      removeLine(el.closest('[data-whcp-line]'));
      return;
    }
    if ((el = t.closest('[data-whcp-undo-btn]'))) {
      undoRemove(el);
      return;
    }
    if (t.closest('[data-whcp-undo-close]')) {
      hideUndo();
      return;
    }
    if (t.closest('[data-whcp-promo-apply]')) {
      applyPromo();
      return;
    }
    if (t.closest('[data-whcp-promo-suggest]')) {
      var p = promoEls();
      if (p && p.input) {
        p.input.value = readSavedPromo().toUpperCase();
        applyPromo();
      }
      return;
    }
    if ((el = t.closest('[data-whcp-code-remove]'))) {
      removeCode(el.getAttribute('data-whcp-code-remove'));
      return;
    }
    if ((el = t.closest('[data-whcp-copy]'))) {
      copyCode(el);
      return;
    }
    if (t.closest('[data-wish]')) {
      /* wise.js traite le clic (écouteur sur document) ; on met ensuite l'état à jour ici. */
      window.setTimeout(function () {
        if (inst) syncWish(inst.el);
      }, 0);
      return;
    }
    if (t.closest('[data-whcp-reco]')) {
      if ((el = t.closest('[data-quick-open]'))) {
        e.preventDefault();
        toggleQuick(el);
        return;
      }
      if (t.closest('[data-quick-close]')) {
        e.preventDefault();
        closeQuick(true);
        return;
      }
      if ((el = t.closest('[data-quick-variant]'))) {
        e.preventDefault();
        if (el.disabled) return;
        var wrap = el.closest('[data-card-quick]');
        var opener = wrap ? wrap.querySelector('[data-quick-open]') : null;
        closeQuick(false);
        focusEl(opener);
        addVariant(parseInt(el.getAttribute('data-quick-variant'), 10), opener, el.closest('.card'));
      }
    }
  }

  function onKeydown(e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if ((e.key === ' ' || e.key === 'Spacebar') && t.matches('a[data-whcp-step], a[data-whcp-remove]')) {
      e.preventDefault();
      t.click();
      return;
    }
    if (e.key === 'Enter') {
      /* Jamais d'envoi implicite du formulaire : son bouton par défaut est « Commander ». */
      if (t.matches('[data-whcp-qty]')) {
        e.preventDefault();
        commitInput(t);
        return;
      }
      if (t.matches('[data-whcp-promo-input]')) {
        e.preventDefault();
        applyPromo();
        return;
      }
    }
    if (e.key === 'Escape' && t.closest && t.closest('[data-whcp-reco] [data-card-quick]')) {
      closeQuick(true);
    }
  }

  function onChange(e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-whcp-qty]')) commitInput(t);
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || form.nodeType !== 1 || !form.matches) return;

    /* Cartes produit des suggestions : ajout sans quitter la page. */
    if (form.matches('form[data-ajax-cart]') && form.closest('[data-whcp-reco]')) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      addVariant(id ? parseInt(id.value, 10) : 0, form.querySelector('[type="submit"]'), form.closest('.card'));
      return;
    }

    /* Formulaire du panier : seul un vrai clic sur Commander l'envoie, et pas pendant une mise à jour. */
    if (inst && form.id === 'whcp-form-' + inst.id) {
      var submitter = e.submitter;
      var isCheckout = submitter ? submitter.name === 'checkout' : Date.now() - state.checkoutClick < 1000;
      if (!isCheckout || state.inflight > 0 || Object.keys(state.pending).length > 0) e.preventDefault();
    }
  }

  /* ---------- Démarrage, éditeur ---------- */
  function teardown() {
    if (!inst) return;
    inst.observers.forEach(function (io) {
      try {
        io.disconnect();
      } catch (err) {
        /* déjà arrêté */
      }
    });
    inst.observers = [];
  }

  /* La note d'origine est sauvegardée par wise.js ([data-cart-note], liée au chargement).
     Une note redessinée ensuite (section rechargée, retour du panier vide) n'est plus liée
     par wise.js : on la sauvegarde ici, de la même façon. */
  function bindNoteFallback(el) {
    $$('[data-cart-note]', el).forEach(function (field) {
      if (field.__whcpNote) return;
      field.__whcpNote = true;
      field.addEventListener('blur', function () {
        jsonPost(R.update, { note: field.value }).catch(report);
      });
    });
  }

  function boot(scope) {
    var el = null;
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-whcp]')) el = scope;
    else if (scope && typeof scope.querySelector === 'function') el = scope.querySelector('[data-whcp]');
    if (!el || el.__whcpInit) return;
    el.__whcpInit = true;

    inst = { el: el, id: el.getAttribute('data-section-id') || '', observers: [] };
    el.classList.add('is-js');
    el.addEventListener('click', onClick);
    el.addEventListener('keydown', onKeydown);
    el.addEventListener('change', onChange);
    el.addEventListener('submit', onSubmit);

    enhance(el);
    syncWish(el);
    setupEstimate(el);
    setupContinue(el);
    setupSaved(el);
    setupBar(el);
    setupReco(el);
    setupRecent(el);
    if (promoEls()) getCart().then(renderCodes).catch(noop);
    if (state.booted) bindNoteFallback(el);
    state.booted = true;

    bindGlobals();
    syncCheckout();
  }

  var extTimer = 0;
  function scheduleExternalRefresh() {
    if (!inst) return;
    window.clearTimeout(extTimer);
    extTimer = window.setTimeout(function () {
      enqueue(function () {
        return refresh({ external: true }).then(function () {
          if (!inst) return null;
          var count = parseInt(inst.el.getAttribute('data-count'), 10);
          if (count >= 0) setHeaderCount(count, true);
          return promoEls() ? getCart().then(renderCodes) : null;
        });
      });
    }, 250);
  }

  function watchDrawer() {
    var body = document.getElementById('drawer-body');
    if (!body || body.__whcpWatch || !('MutationObserver' in window)) return;
    body.__whcpWatch = true;
    new window.MutationObserver(function () {
      /* wise.js vient de redessiner le tiroir avec le panier à jour. */
      state.drawerStale = false;
      if (Date.now() - state.lastOwn < 1500) return;
      scheduleExternalRefresh();
    }).observe(body, { childList: true });
  }

  function bindGlobals() {
    if (state.globals) return;
    state.globals = true;

    watchDrawer();

    /* Tiroir périmé sur la page panier : le panier est déjà sous les yeux. */
    document.addEventListener('click', function (e) {
      if (!state.drawerStale || !inst) return;
      var opener = e.target && e.target.closest ? e.target.closest('[data-drawer-open]') : null;
      if (!opener) return;
      e.preventDefault();
      e.stopPropagation();
      try {
        window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' });
      } catch (err) {
        window.scrollTo(0, 0);
      }
      focusEl(inst.el.querySelector('[data-whcp-title]'));
    }, true);

    /* Fermeture des choix de taille des suggestions au clic à l'extérieur. */
    document.addEventListener('click', function (e) {
      if (!inst || !e.target || !e.target.closest) return;
      if (!e.target.closest('[data-whcp-reco] [data-card-quick]')) closeQuick(false);
    });

    /* Panier modifié ailleurs sur la page (tiroir, application, autre composant). */
    document.addEventListener(EVENT, function (e) {
      var detail = e && e.detail ? e.detail : {};
      if (detail.source === 'cart-page') return;
      state.drawerStale = false;
      scheduleExternalRefresh();
    });

    ['shopify:cart:lines-update', 'shopify:cart:discount-update'].forEach(function (name) {
      document.addEventListener(name, function (e) {
        var done = function () {
          scheduleExternalRefresh();
        };
        if (e && e.promise && typeof e.promise.then === 'function') e.promise.then(done, done);
        else window.setTimeout(done, 600);
      });
    });

    /* Retour arrière depuis le paiement : la page sort du cache du navigateur avec un panier
       et des boutons possiblement périmés (bouton de paiement resté bloqué) : on la recharge. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && inst) window.location.reload();
    });

    var hiddenAt = 0;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        hiddenAt = Date.now();
        return;
      }
      if (hiddenAt && Date.now() - hiddenAt > 30000) scheduleExternalRefresh();
      hiddenAt = 0;
    });

    /* Favoris modifiés dans un autre onglet. */
    window.addEventListener('storage', function (e) {
      if (e.key === KEY_WISH && inst) syncWish(inst.el);
    });

    /* Éditeur de thème */
    document.addEventListener('shopify:section:unload', function (e) {
      if (inst && e.target && e.target.contains && e.target.contains(inst.el)) {
        teardown();
        inst = null;
      }
    });
    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
    });
  }

  function start() {
    try {
      bindGlobals();
      boot(document);
    } catch (err) {
      report(err);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(window, document);
